




































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'

import { UserService } from '@/services'
import validationRules from '@/utils/validation'

export default Vue.extend({
  name: 'WaitListNotifyMe',

  directives: {
    mask,
  },

  props: {
    waitListId: {
      type: String,
      default: () => null,
    },
  },

  data() {
    return {
      loading: false,
      nameRules: validationRules.nameRules,
      phoneRules: validationRules.phoneRules,
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
  },

  methods: {
    async handleNotifyMeClicked() {
      if (!this.$refs.notifyMeContactInfoForm.validate()) return

      this.loading = true

      await UserService.setPersonalInfo(this.user.first_name, this.user.last_name, this.user.phone)

      if (this.waitListId) {
        this.$toast.success(`Great! You'll be notified when you when you can redeem this offer`)

        this.$emit('wait-list-modal-close')
        return
      }

      this.$emit('wait-list-modal-create')
    },
  },
})
